import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

import CommonAlert from "@/components/CommonAlert";
import { useUpdateUserLoginStatusMutation } from "@/requests/user.mutations";
import { useUsersTableActions, userUsersLoginStatusInfo } from "@/stores/use-users-table";

function UserCommonUpdateDialog() {
    const { t } = useTranslation();
    const { mutateAsync, isPending } = useUpdateUserLoginStatusMutation();

    const loginInfo = userUsersLoginStatusInfo();
    const { updateLoginStatusInfo } = useUsersTableActions();
    const handleConfirm = async () => {
        if (isPending || !loginInfo) return;
        try {
            const res = await mutateAsync(loginInfo);
            enqueueSnackbar(t(res.message || ""), { variant: "success" });
        } catch (error) {
            console.error("UserCommonUpdateDialog error:", error);
        }
        handleClose();
    };

    const handleClose = () => {
        updateLoginStatusInfo(null);
    };

    return (
        <CommonAlert
            open={!!loginInfo}
            loading={isPending}
            description="confirmations.userLoginStatus"
            color="error"
            onClose={handleClose}
            handleConfirm={handleConfirm}
            html
            descriptionOpts={{
                name: loginInfo?.name || "",
                count: loginInfo?.disabled ? 2 : 1,
            }}
        />
    );
}

export default UserCommonUpdateDialog;
